module.exports = __webpack_public_path__ + "static/media/contract-law.743f2f45.jpg";